import React from "react";
import { TableRow, TableCell } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Edit, Trash } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { UserWithProfile } from "@/models/user";

interface UserTableRowProps {
  user: UserWithProfile;
  onEditUser: (user: UserWithProfile) => void;
  onDeleteUser: (user: UserWithProfile) => void;
}

const UserTableRow: React.FC<UserTableRowProps> = ({ 
  user, 
  onEditUser, 
  onDeleteUser 
}) => {
  return (
    <TableRow>
      <TableCell className="font-medium">
        {user.profile?.full_name || "Sin nombre"}
      </TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>
        {user.profile?.role === "admin" ? (
          <Badge className="bg-blue-500">Administrador</Badge>
        ) : user.profile?.role === "contabilidad" ? (
          <Badge className="bg-green-500">Contabilidad</Badge>
        ) : user.profile?.role === "mantenimiento" ? (
          <Badge className="bg-amber-500">Enc Mantenimiento</Badge>
        ) : (
          <Badge variant="outline">Vendedor</Badge>
        )}
      </TableCell>
      <TableCell className="text-right">
        <div className="flex justify-end gap-2">
          <Button 
            variant="ghost" 
            size="icon"
            onClick={() => onEditUser(user)}
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button 
            variant="ghost" 
            size="icon" 
            className="text-red-500 hover:text-red-700"
            onClick={() => onDeleteUser(user)}
          >
            <Trash className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default UserTableRow;
